import { useRef, useState } from 'react';
import styles from './CallConnectedScreen.module.scss';
import ControlsBar from '../ControlsBar/ControlsBar';
import ParticipantsPanel from '../ParticipantsPanel/ParticipantsPanel';
import TopBar from '../TopBar/TopBar';
import VideoGrid from '../VideoGrid/VideoGrid';
import ViewSettingsPanel from '../ViewSettingsPanel/ViewSettingsPanel';
import VideoCallSwitchPopup from '../VideoCallSwitchPopup/VideoCallSwitchPopup';
import { useCallConnectedScreen } from '@/features/calls/viewmodels/useCallConnectedScreen';

/**
 * Pure rendering component — zero business logic.
 * All logic (participant mapping, layout, audio/video toggle, etc.) from useCallConnectedScreen().
 * 239→70 lines.
 */
export function CallConnectedScreen() {
   const containerRef = useRef(null);
   const [settingsOpen, setSettingsOpen] = useState(false);

   const {
      allParticipants,
      displayedParticipants,
      primaryForMode,
      activeSpeakerId,
      pinnedId,
      isAudioMuted,
      isVideoMuted,
      viewMode,
      effectiveViewMode,
      maxTiles,
      hideNoVideo,
      handleToggleAudio,
      handleToggleVideo,
      handlePin,
      handleEndCall,
      handleSetViewMode,
      handleSetMaxTiles,
      handleSetHideNoVideo,
      showParticipantsPanel,
      handleToggleParticipantsPanel,
      isReconnecting,
   } = useCallConnectedScreen();

   const countClass = (() => {
      if (displayedParticipants.length <= 2) return styles.count2;
      if (displayedParticipants.length <= 4) return styles.count4;
      if (displayedParticipants.length <= 6) return styles.count6;
      return styles.count8;
   })();

   return (
      <div className={`${styles.callScreenContainter} ct-flex ct-fcol`}>
         <TopBar onParticipantsPanel={handleToggleParticipantsPanel} />

         <div className={`ct-flex ct-flex1 ct-relative ${styles.main} ${countClass}`}>
            <div className={`ct-flex ct-aiCenter ct-flex1 ${styles.videoArea}`} ref={containerRef}>
               <VideoGrid
                  participants={displayedParticipants}
                  viewMode={effectiveViewMode}
                  primary={primaryForMode}
                  activeSpeakerId={activeSpeakerId}
                  pinnedId={pinnedId}
                  handlePin={handlePin}
                  onParticipantsPanel={handleToggleParticipantsPanel}
                  containerRef={containerRef}
                  hasSidePanel={false}
               />
            </div>

            {showParticipantsPanel && (
               <ParticipantsPanel
                  participants={allParticipants}
                  pinnedId={pinnedId}
                  handlePin={handlePin}
                  onClose={handleToggleParticipantsPanel}
               />
            )}
         </div>

         <ControlsBar
            roomName="MirrorFly Meet"
            isAudioMuted={isAudioMuted}
            setAudioMuted={handleToggleAudio}
            videoMuted={isVideoMuted}
            setvideoMuted={handleToggleVideo}
            onParticipantsPanel={handleToggleParticipantsPanel}
            onEndCall={handleEndCall}
            isReconnecting={isReconnecting}
         />

         <ViewSettingsPanel
            open={settingsOpen}
            onClose={() => setSettingsOpen(false)}
            viewMode={viewMode}
            setViewMode={handleSetViewMode}
            maxTiles={maxTiles}
            setMaxTiles={handleSetMaxTiles}
            hideNoVideo={hideNoVideo}
            setHideNoVideo={handleSetHideNoVideo}
         />
         <VideoCallSwitchPopup />
      </div>
   );
}
